<script lang="ts">
    import {f7, Page, Block, Button, Chip, Icon} from 'framework7-svelte';
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';
    
    import { navparts } from '../utils/navparts';
    import ActionBar from '../components/ActionBar.svelte';
    import Header from '../components/Header.svelte';
    import { PERMISSION_MODIFY_PROJECTS, PERMISSION_VIEW_INSIGHT } from '../utils/permissions';
    import {getProjects} from "../api/projects.api";
    import type {Project} from "../types/project.type";

    let projectItems: Project[] = [];

    $: navparts.set([{ name: $_('shared.PROJECTS'), href: '/projects' }]);

    onMount(async () => {
        projectItems = await getProjects();
    });
    function goTo(url) {
        f7.views.main.router.navigate(url);
    }
    
    function copyIdAndNotify(project: Project) {
        navigator.clipboard.writeText(project.id);
        f7.toast.create({
            text: $_('shared.COPIED_TO_CLIPBOARD', { values: { item: `Id van '${project.name}'` }}),
            closeButton: true,
            closeTimeout: 1000,
            position: 'center'
        }).open();
    }
</script>

<Page>
    <Header />

    <ActionBar>
        {#if $PERMISSION_MODIFY_PROJECTS}
            <Button outline class="display-inline-flex padding-horizontal" href="/project/new" iconMaterial="add">
                {$_('shared.ADD')}
            </Button>
        {/if}
    </ActionBar>

    <Block>
        {#if projectItems}
            <div class="card data-table">
                <table>
                    <thead>
                        <tr>
                            <th style="width: 30em">
                                <span class="table-head-label">
                                    {$_('shared.HEADER_ID')}
                                </span>
                            </th>
                            <th class="input-cell">
                                <span class="table-head-label">
                                    {$_('shared.HEADER_NAME')}
                                </span>
                                <div class="input">
                                    <input type="text" placeholder="Filter" />
                                </div>
                            </th>
                            {#if $PERMISSION_VIEW_INSIGHT}
                            <th>
                                <span class="table-head-label">
                                    {$_('shared.HEADER_MEASUREMENTS')}
                                </span>
                            </th>
                            {/if}
                        </tr>
                    </thead>
                    <tbody>
                        {#each projectItems as item, i}
                            <tr
                                class="table-row"
                            >
                                <td>
                                    <span on:click={() => goTo($PERMISSION_VIEW_INSIGHT ? `/project/${item.id}/insights` : `/project/${item.id}/dashboard`)}>
                                        {item.id}
                                    </span>
                                    {#if $PERMISSION_MODIFY_PROJECTS}
                                    <span 
                                        on:click={() => copyIdAndNotify(item)} 
                                        class="table-sub-label"
                                        title={$_('shared.COPIED_TO_CLIPBOARD', { values: { item: `Id van '${item.name}'` }})}>
                                        <Icon f7="doc_on_clipboard" size="25"/>
                                    </span>
                                    {/if}
                                </td>
                                <td on:click={() => goTo($PERMISSION_VIEW_INSIGHT ? `/project/${item.id}/insights` : `/project/${item.id}/dashboard`)}>{item.name}</td>
                                {#if $PERMISSION_VIEW_INSIGHT}
                                <td on:click={() => goTo($PERMISSION_VIEW_INSIGHT ? `/project/${item.id}/insights` : `/project/${item.id}/dashboard`)}>
                                    {#if item.hereRoutingInterval}
                                        <Chip text={"here-routing"} mediaBgColor="blue" media={item.hereRoutingInterval.toString()} class="margin-right" />
                                    {/if}
                                    {#if item.hereTrafficInterval}
                                        <Chip text={"here-traffic"} mediaBgColor="blue" media={item.hereTrafficInterval.toString()} class="margin-right" />
                                    {/if}
                                    {#if item.mapboxCongestionInterval}
                                        <Chip text={"mapbox-congestion"} mediaBgColor="blue" media={item.mapboxCongestionInterval.toString()} class="margin-right" />
                                    {/if}
                                    {#if item.ndwIntensityInterval}
                                        <Chip text={"ndw-intensity"} mediaBgColor="blue" media={item.ndwIntensityInterval.toString()} class="margin-right" />
                                    {/if}
                                </td>
                                {/if}
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>
        {/if}
    </Block>
</Page>

<style lang="scss">
    .table-row {
        cursor: pointer;
    }
    .table-sub-label {
      float: right;
    }
</style>
